
define('ldsh!modules/stats/templates/main', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-item-inner-spinner js-spinner">\n    <div class="ed-loading"> <i class="ed-icon ed-icon-refresh" aria-hidden="true"></i></div>\n</div>\n\n<div class="ed-table-container"></div>';

}
return __p
};});

